<template>
  <div>
    <el-row style="padding-bottom: 10px" @keyup.enter.native="search">
      <el-col :span="24" class="search-box">
        <span
          ><label>设备编号:</label>
          <el-input style="width:200px;"
            class="search-input"
            v-model="deviceId"
            placeholder="请输入设备编号"
          ></el-input>
        </span>
        <span
          ><label>员工：</label>
          <DropdownSelect style="width:200px;"
            v-model="staffId"
            :action="api.shop.staff.all"
            textField="name"
            valueField="id"
          ></DropdownSelect>
        </span>
        <span
          ><label>日期：</label>
          <el-date-picker style="width:250px;"
            v-model="date"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </span>
        <span>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button type="primary" @click="exportData">导出</el-button>
        </span>
      </el-col>
    </el-row>
    <page-table
      :data-api="this.api.shop.order"
      :viewable="false"
      keyField="id"
      :deletable="false"
      :editable="false"
    >
      <el-table-column prop="id" label="编号" width="80"></el-table-column>
      <el-table-column prop="deviceId" label="设备编号"></el-table-column>
      <el-table-column prop="shopDeviceTypeName" label="设备类型"></el-table-column>
      <el-table-column prop="staffName" label="操作员工"></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        :formatter="statusFormatter"
      ></el-table-column>
      <el-table-column v-if="!isMobile()"
        prop="payType"
        label="支付类型"
        :formatter="payTypeFormatter"
      ></el-table-column>
      <el-table-column
        prop="payTime"
        label="启动时间"
        :formatter="dateFormatter"
      ></el-table-column>
      <el-table-column
        prop="workDeadline"
        label="结束时间"
        :formatter="dateFormatter"
      ></el-table-column>
    </page-table>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {
      deviceId: null,
      staffId: null,
      date: [null, null],
    };
  },
  created: function () {
    let that = this;
    let query = that.getQuery();
    that.deviceId = query.deviceId ? parseInt(query.deviceId) : null;
    that.staffId = query.staffId ? parseInt(query.staffId) : null;
    that.date[0] = query.startDate ? new Date(parseInt(query.startDate)) : null;
    that.date[1] = query.endDate ? new Date(parseInt(query.endDate)) : null;
  },
  methods: {
    dateFormatter(row, column, cellValue, index) {
      if (!cellValue) {
        return cellValue;
      }
      return this.dateFormat("yyyy-mm-dd HH:MM:SS", new Date(cellValue));
    },
    statusFormatter(row, column, cellValue, index) {
      if (0 == cellValue) {
        return "待支付";
      } else if (1 == cellValue) {
        return "启动中";
      } else if (2 == cellValue) {
        return "启动成功";
      } else if (3 == cellValue) {
        return "启动失败";
      } else if (4 == cellValue) {
        return "订单关闭";
      }
      return cellValue;
    },
    payTypeFormatter(row, column, cellValue, index) {
      if (1 == cellValue) {
        return "管理员";
      } else if (2 == cellValue) {
        return "门店";
      }
      return cellValue;
    },
    search() {
      let params = this.getQuery();
      params.deviceId = this.deviceId;
      params.staffId = this.staffId;
      params.startDate =
        this.date && this.date[0] ? this.date[0].getTime() : null;
      params.endDate =
        this.date && this.date[1] ? this.date[1].getTime() : null;
      params.page = 1;
      let that = this;
      this.$router.replace({ query: params }, null, function () {
        that.$router.go(0);
      });
    },
    exportData() {
      var that = this;
      let params = this.getQuery();
      params.deviceId = this.deviceId;
      params.staffId = this.staffId;
      params.startDate =
        this.date && this.date[0] ? this.date[0].getTime() : null;
      params.endDate =
        this.date && this.date[1] ? this.date[1].getTime() : null;
      that.api.shop.order.exportData(params).then((response) => {
        if (!response.data.errorCode) {
          var bstr = atob(response.data.data),
            n = bstr.length,
            u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          var blob = new Blob([u8arr], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          /*if (window.URL.createObjectURL(blob).indexOf(location.host) < 0) {
            //ie不支持
            this.href = window.navigator.msSaveOrOpenBlob(blob, "export.xlsx");
          } else {
            this.download = "export.xlsx";
            this.href = URL.createObjectURL(blob);
          }
          window.open(this.href);
          console.log(response.data.data);*/
          // 创建一个a链接
          var aTag = document.createElement("a");
          // 给下载文件命名
          aTag.download = "export.xlsx";
          // 创建下载
          aTag.href = URL.createObjectURL(blob);
          // 开始下载
          aTag.click();
          URL.revokeObjectURL(blob);
        }
      });
    },
    getQuery() {
      return Object.assign({}, this.$route.query);
    },
  },
};
</script>

<style scoped>
@media screen and (max-device-width: 960px) {
  .search-input {
    width: 105px;
  }
}
@media screen and (min-device-width: 960px) {
  .search-input {
    width: 150px;
  }
}
.search-box span {
  display: inline-block;
  padding: 2px 2px 2px 0px;
}
.search-box span label {
  display: inline-block;
  width: 55px;
}
</style>


// WEBPACK FOOTER //
// List.vue?5a830934